import NextLink from 'next/link';
import { ComponentProps } from 'react';

const DISPLAY_NAME = 'Link';

type Props = Omit<ComponentProps<typeof NextLink>, 'prefetch'>;

export const Link = (props: Props) => {
  return <NextLink {...props} prefetch={false} />;
};

Link.displayName = DISPLAY_NAME;
